import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { http, join, isLoggedIn, logout } from '@loyalup/core';
import { Layout, Button, Field, Form, Link, AuthPanel } from '@loyalup/ui';

import { ReactComponent as CircleXIcon } from 'icons/circle-x.svg';

import s from './AcceptInvite.module.css';

const STATUSES = {
  INVALID_TOKEN: 'invalid_token',
  INPUT: 'input',
  LOADING: 'loading',
  ALREADY_LOGGED_IN: 'already_logged_in',
};

const onSubmit = async (token, form, setStatus, setErrors) => {
  setStatus(STATUSES.LOADING);
  setErrors({});
  const [ok, errors] = await join({ ...form, token });

  if (ok) {
    window.location = '/';
  } else if (errors.token) {
    setStatus(STATUSES.INVALID_TOKEN);
  } else {
    setStatus(STATUSES.INPUT);
    setErrors(errors);
  }
};

const ResetPassword = ({ match }) => {
  const [t] = useTranslation();
  const { token } = match.params;
  const [form, setForm] = useState({ first_name: '', last_name: '', password: '' });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(isLoggedIn() ? STATUSES.ALREADY_LOGGED_IN : STATUSES.LOADING);
  const loading = status === STATUSES.LOADING;

  const join = async () => {
    const { ok, user } = await http('POST', '/join/token', { token });
    if (ok) {
      setStatus(STATUSES.INPUT);
      setForm({ ...user, password: '' });
    } else {
      setStatus(STATUSES.INVALID_TOKEN);
    }
  };

  useEffect(() => {
    if (status !== STATUSES.ALREADY_LOGGED_IN) {
      join();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout center title={t('Регистрация')}>
      <AuthPanel>
        <div className={s.root}>
          {status === STATUSES.ALREADY_LOGGED_IN ? (
            <>
              <h1>{t('Вы уже авторизованы')}</h1>
              <p className={s.hint}>{t('Для продолжения нужно выйти из аккаунта')}</p>
              <Button
                onClick={() => {
                  logout();
                  setStatus(STATUSES.LOADING);
                  join();
                }}
                className={s.button}
                fixedWidth={200}
                center
              >
                {t('Выйти')}
              </Button>
            </>
          ) : (
            <>
              <div className={s.header}>
                <h1>{t('Регистрация')}</h1>
              </div>
              {status === STATUSES.INVALID_TOKEN && (
                <div className={s.hintContainer}>
                  <CircleXIcon className={s.xIcon} />
                  <p className={s.hint}>
                    {t(
                      'Ваш аккаунт уже активирован или ссылка для активации неверна. Используйте емейл и пароль для входа.',
                    )}
                    <br />
                    <br />
                    <Link to="/login">{t('Войти')}</Link>
                  </p>
                </div>
              )}
              {[STATUSES.INPUT, STATUSES.LOADING].includes(status) && (
                <p className={s.hint}>
                  {t('Пожалуйста, чтобы закончить регистрацию введите данные для вашего аккаунта.')}
                </p>
              )}
              {[STATUSES.INPUT, STATUSES.LOADING].includes(status) && (
                <Form onSubmit={() => onSubmit(token, form, setStatus, setErrors)}>
                  <Field
                    label={t('Имя')}
                    name="first_name"
                    type="text"
                    autoFocus
                    value={form.first_name}
                    error={errors.first_name}
                    disabled={loading}
                    onChange={first_name => setForm({ ...form, first_name })}
                    required
                  />
                  <Field
                    label={t('Фамилия')}
                    name="last_name"
                    type="text"
                    autoFocus
                    value={form.last_name}
                    error={errors.last_name}
                    disabled={loading}
                    onChange={last_name => setForm({ ...form, last_name })}
                  />
                  <Field
                    label={t('Е-мейл')}
                    name="email"
                    type="email"
                    value={form.email}
                    error={errors.email}
                    onChange={email => setForm({ ...form, email })}
                    disabled
                  />
                  <Field
                    label={t('Пароль')}
                    name="password"
                    type="password"
                    value={form.password}
                    error={errors.password}
                    disabled={loading}
                    onChange={password => setForm({ ...form, password })}
                    required
                  />
                  <Button type="submit" fixedWidth={200} loading={loading} center>
                    {t('Зарегистрироваться')}
                  </Button>
                </Form>
              )}
            </>
          )}
        </div>
      </AuthPanel>
    </Layout>
  );
};

export default withRouter(ResetPassword);
